module.exports = __webpack_public_path__ + "img/8M.739735ff.png";